var PropTypes = require('prop-types');
let React = require('react');
let classNames = require('classnames');

class EditableCheckbox extends React.Component {
  static propTypes = {
    children: PropTypes.any,
    class: PropTypes.string,
    dataKey: PropTypes.any.isRequired,
    disabled: PropTypes.bool,
    editMode: PropTypes.bool.isRequired,
    hideLabel: PropTypes.bool,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
  };

  state = {
    highlighted: false,
  };

  handleChange = () => {
    this.props.onChange({key: this.props.dataKey, value: !this.props.value});
  };

  render() {
    let content;

    if (this.props.editMode) {
      content = this.props.disabled ?
        <div className='checkbox-wrapper'>
          <input type='checkbox' id={this.props.dataKey} disabled checked={!!this.props.value} onChange={this.handleChange} />
          <label />
        </div>        :
        <div className='checkbox-wrapper'>
          <input type='checkbox' id={this.props.dataKey} checked={!!this.props.value} onChange={this.handleChange}
            data-event-category={this.props['data-event-category']}
            data-event-action={this.props['data-event-action']} />
          <label />
        </div>;
    } else {
      content =
        <i className={this.props.value ? 'bl bl-checkmark' : 'bl bl-x'} />
      ;
    }

    let wrapperClass = 'editable-checkbox';

    if (this.props.class) {
      wrapperClass += ' ' + this.props.class;
    }

    let hangingIndent = {
      paddingLeft: 35,
      textIndent: -40,
    };

    return (
      <div className={wrapperClass}>
        <div className={classNames('form-control-static', {'form-control--highlighted': this.state.highlighted})}
            style={this.props.editMode ? hangingIndent : {}}>
          <label className='editable-checkbox-blocklabel'>
            {content}
            {!this.props.hideLabel ?
              <span className='editable-checkbox-label' dangerouslySetInnerHTML={{__html: this.props.label ? this.props.label : this.props.children}}>
              </span>              :
              null}
          </label>
        </div>
      </div>
    );
  }
}

module.exports = EditableCheckbox;
